module.exports = __webpack_public_path__ + "assets/a7a92387ec29aafd5eece8f602c837df.mp4";